import { render, staticRenderFns } from "./NewsCategoryFilter.vue?vue&type=template&id=ae221a24"
import script from "./NewsCategoryFilter.vue?vue&type=script&lang=js"
export * from "./NewsCategoryFilter.vue?vue&type=script&lang=js"
import style0 from "./NewsCategoryFilter.vue?vue&type=style&index=0&id=ae221a24&prod&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports